module.exports = __webpack_public_path__ + "img/ledger-live-setting-step-ten.ba9f4aec.png";